import React from "react";
import { useField } from "react-final-form";

import { Stack } from "@bps/fluent-ui";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { NzPracticeAccContractDto } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { DeleteButton } from "@ui-components/DeleteButton.tsx";
import { DropdownField } from "@ui-components/form/DropdownField.tsx";
import { useFieldArray } from "@ui-components/form/submission-form/hooks/useFieldArray.ts";
import { TextInputField } from "@ui-components/form/TextInputField.tsx";

interface SpecifiedTreatmentFieldsProps {
  handleKeyRemove: () => void;
  businessRoleCodes: { key: string; text: string }[];
  name: string;
}

export const SpecifiedTreatmentFields: React.FC<
  SpecifiedTreatmentFieldsProps
> = ({ handleKeyRemove, businessRoleCodes, name }) => {
  const { core } = useStores();
  const readOnly = !core.hasPermissions(Permission.OrgUnitSettingWrite);

  const stpPracticeAccContractFields =
    useFieldArray<NzPracticeAccContractDto>("stpAccContracts").fields;

  const currentStpPracticeBusinessRoleCodes =
    stpPracticeAccContractFields.value.map(value => value.businessRoleCode);

  const {
    input: { value }
  } = useField<NzPracticeAccContractDto>(name, {
    subscription: { value: true }
  });

  const filteredStpPracticeBusinessRoleCodes = businessRoleCodes.filter(
    item => {
      return (
        item.key === value?.businessRoleCode ||
        !currentStpPracticeBusinessRoleCodes?.includes(item.key)
      );
    }
  );

  return (
    <Stack horizontal tokens={{ childrenGap: 8 }}>
      <Stack.Item styles={{ root: { flexGrow: 1, flexBasis: 0 } }}>
        <TextInputField
          required
          readOnly={readOnly}
          name={`${name}.contractId`}
        />
      </Stack.Item>
      <Stack
        horizontal
        tokens={{ childrenGap: 8 }}
        styles={{ root: { flexGrow: 1, flexBasis: 0 } }}
      >
        <DropdownField
          fieldItemStyles={{ root: { flexGrow: 1 } }}
          name={`${name}.businessRoleCode`}
          options={filteredStpPracticeBusinessRoleCodes}
          required
        />
        <DeleteButton
          onClick={handleKeyRemove}
          disabled={readOnly}
          styles={{ root: { alignSelf: "baseline" } }}
        />
      </Stack>
    </Stack>
  );
};
